import type { ComponentPropsWithRef } from "react";

export const SearchIcon = (props: ComponentPropsWithRef<"svg">) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M23 24L16 17" strokeLinecap="round" />
    <circle cx="10" cy="10" r="9" />
  </svg>
);
